import jiraLogo from './jira.svg';

export const CONNECTOR_SERVICES = [
  {
    id: 'jira-cloud',
    name: 'Jira Cloud',
    description: 'Issue tracking and project management',
    logo: jiraLogo,
    configuration: 'jira-cloud',
  },
  // Future connector types can be added here
  // {
  //   id: 'slack',
  //   name: 'Slack',
  //   description: 'Connect to Slack for team communication and notifications',
  //   icon: '💬',
  //   color: 'info',
  // },
  // {
  //   id: 'github',
  //   name: 'GitHub',
  //   description: 'Connect to GitHub for repository and pull request management',
  //   icon: '🐙',
  //   color: 'dark',
  // },
];
